import { render, staticRenderFns } from "./BlockArea.vue?vue&type=template&id=236787aa&scoped=true"
import script from "./BlockArea.vue?vue&type=script&lang=js"
export * from "./BlockArea.vue?vue&type=script&lang=js"
import style0 from "./BlockArea.vue?vue&type=style&index=0&id=236787aa&prod&lang=less"
import style1 from "./BlockArea.vue?vue&type=style&index=1&id=236787aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236787aa",
  null
  
)

export default component.exports